/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.dashboard.admin.controllers', [
  'acme.common.service.api',
  'acme.common.service.calendar'
])

.controller('DashboardAdminController', ['$scope', '$filter', 'ApiService', 'CalendarService', 'CompanyData', 'UserPreferencesService', function($scope, $filter, ApiService, CalendarService, CompanyData, UserPreferencesService) {

  var watchers = {};

  $scope.dashboardAdmin = {


    revenue: [],

    analytics: {
      personnel: {
        name: 'Personnel',
        capacity: 300,
        allocated: 213
      },
      facilities: {
        name: 'Facilities',
        capacity: 300,
        allocated: 53
      },
      equipment: {
        name: 'Equipment',
        capacity: 300,
        allocated: 268
      },
      revenue: {
        total: 0,
        member: 0,
        individual: 0,
        group: 0
      },
      tickets: {
        total: 0,
        member: 0,
        individual: 0,
        group: 0
      }

    },


    intervals: [
      {
        name: '1D',
        scale: 'day'
      },
      { name: '1W',
        scale: 'week'
      },
      {
        name: '1M',
        scale: 'month'
      }
    ],

    displayOptions: [
      {
        label: 'Top 3 Grossing',
        name: 'Ascending'
      },
      {
        label: 'Lowest 3 Grossing',
        name: 'Descending'
      },
      {
        label: 'Total Gross',
        name: 'gross'
      }
    ],

    admissionTypes: {
      individual: true,
      group: true,
      member: true
    },

    display: {},
    selectedInterval: '',
    startDate: '',
    endDate: '',
    initted: false,
    company: {},
    dateFormat: UserPreferencesService.getDateFormat('shortDate', 'dateFormat'),

    init: function() {
      var d = new Date();

      this.selectedInterval = this.intervals[1].scale;

      this.endDate = new Date();
      this.updateStartDate(this.selectedInterval);
      this.endMaxDate = new Date();
      this.startMaxDate = new Date();

      $scope.$emit('Application::contentTitleChange', {});

      watchers.startDate = $scope.$watch('dashboardAdmin.startDate', function() {
        if ($scope.dashboardAdmin.initted) {
          $scope.dashboardAdmin.getAnalytics();
        }
      });

      watchers.endDate = $scope.$watch('dashboardAdmin.endDate', function() {
        if ($scope.dashboardAdmin.initted) {
          $scope.dashboardAdmin.getAnalytics();
        }
        $scope.dashboardAdmin.initted = true;
      });

      watchers.selectedInterval = $scope.$watch('dashboardAdmin.selectedInterval', function(n) {
        $scope.dashboardAdmin.updateStartDate(n);
      });

      if (CompanyData && CompanyData.data.success) {
        this.success.init(CompanyData);
      }else{
        this.error.init(CompanyData);
      }

    },


    parseRevenue: function(type) {
      return $filter('simpleCurrency')(this.analytics.revenue[type]);
    },

    getAnalytics: function() {

      ApiService.analytics.revenue.detail({
        startTime: CalendarService.toISO8601(this.startDate),
        endTime: CalendarService.toISO8601(this.endDate),
        sortOrder: this.display.name || 'asc'
      }).then(this.success.getAnalytics, this.error.getAnalytics);

    },

    updateStartDate: function(interval) {
      var newDate;

      switch(interval) {
        case 'day':
          newDate = new Date(this.endDate.getFullYear(), this.endDate.getMonth(), this.endDate.getDate() - 1);
          break;
        case 'week':
          newDate = new Date(this.endDate.getFullYear(), this.endDate.getMonth(), this.endDate.getDate() - 7);
          break;
        case 'month':
        /* falls through */
        default:
          newDate = new Date(this.endDate.getFullYear(), this.endDate.getMonth() - 1, this.endDate.getDate());
          break;
      }

      this.startDate = newDate;
    },

    success: {
      init: function(response) {
        $scope.dashboardAdmin.company = response.data.tenant;
        $scope.$emit('Application::contentTitleChange', {
          title: $scope.dashboardAdmin.company.name
        });
      },

      getAnalytics: function(response) {
        $scope.dashboardAdmin.revenue = response.data.payload;
      }
    },

    error: {
      init: function(response) {},

      getAnalytics: function(response) {}
    },

    onDestroy:  function() {
      var watcher;
      for (watcher in watchers) {
        if (watchers.hasOwnProperty(watcher)) {
          watchers[watcher]();
        }
      }
    }

  };

  $scope.dashboardAdmin.init();

}])
.controller('DashboardDatePickerController', ['$scope', '$timeout', 'UserPreferencesService', function($scope, $timeout, UserPreferencesService) {
  $scope.dashboardDatePicker = {

    isOpen: false,
    
    dateFormat: UserPreferencesService.getDateFormat('fieldDate', 'dateFormat'),

    init: function() {
      this.today();
      $scope.initDate = new Date('2016-15-20');
      $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
      $scope.format = $scope.formats[1];
      $scope.$on('UserPreferencesService:onDateFormatLoad', this.onDateFormatLoad);
      $timeout(function () {
          $scope.dashboardDatePicker.isPreferenceLoaded = true;
      },0);
    },

    today: function() {
      this.dt = new Date();
    },
    clear: function () {
      $scope.dt = null;
    },

    toggleMin: function() {
      $scope.minDate = $scope.minDate ? null : new Date();
    },
    open: function($event) {
      $event.preventDefault();
      $event.stopPropagation();

      this.isOpen = true;
    },

    dateOptions: {
      formatYear: 'yy',
      startingDay: UserPreferencesService.getStartDayOfWeek(),
      formatDayTitle: UserPreferencesService.getDateFormat('month', 'dateFormat')
    },
    
    onDateFormatLoad: function (e, data) {
      var self = $scope.dashboardDatePicker;
      self.dateFormat  = UserPreferencesService.getDateFormat('fieldDate', 'dateFormat');
      self.dateOptions = {
        formatYear: 'yy',
        startingDay: UserPreferencesService.getStartDayOfWeek(),
        formatDayTitle: UserPreferencesService.getDateFormat('month', 'dateFormat')
      };
    }

  };
  
  $scope.dashboardDatePicker.init();

}])
.filter('simpleCurrency', [ '$filter', '$locale', function(filter, locale) {
  var currencyFilter = filter('currency'),
      formats = locale.NUMBER_FORMATS;

  return function(amount, currencySymbol) {
    var value = currencyFilter(amount, currencySymbol),
        sep = value.indexOf(formats.DECIMAL_SEP);

    if(amount >= 0) {
      return value.substring(0, sep);
    }
    return value.substring(0, sep) + ')';
  };
}]);